import virtual from "workflow/vue/3/virtual"

export default () =>
  virtual({
    data: () => ({
      read_only: true,
      files: {},
    }),
  })
